// @flow
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/statistic.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import './styles.scss'
import config from 'config'
import type { Municipality } from 'sources/types'
import type { CategorySelectionState } from 'components/selector/reducer'

type AdditionalProps = {}

type Props = AdditionalProps & Municipality & CategorySelectionState

/**
 * Small component that provides additional details on a municipality.
 *
 * Proposed use within the list on the bottom of the map and as a popup
 * information window
 *
 * @param {object} props
 */
export function MunicipalityDetail ({
  Belastung = 5,
  Gemeindename = 'Bern',
  Kanton = 'BE',
  Rank = 100,
  income = 150000
}: Props): React.Element<'div'> {
  let explanation = (
    <p>
      À {Gemeindename} un contribuable avec un revenu de{' '}
      {config.formatAsIntegerCurrency(income)} devrait payer environ{' '}
      <strong>
        {config.formatAsIntegerCurrency(income * Belastung / 100)}
      </strong>{' '}
      d'impôts. Cette commune se trouve ainsi en <strong>rang {Rank}</strong> place des catégories choisies.
    </p>
  )

  let cantonAddition = Kanton && Kanton !== '' ? ` (${Kanton})` : ''

  return (
    <div className='municipality-detail'>
      <div className='ui tiny infographic header'>
        {Gemeindename}
        {cantonAddition}
      </div>

      <div className='ui vertical very fitted segment'>
        <div className='ui two tiny statistics'>
          <div className='ui statistic'>
            <div className='value'>
              {config.formatAsPercent(Belastung / 100)}
            </div>
            <div className='label'>Charge</div>
          </div>
          <div className='ui statistic'>
            <div className='value'>{Rank}</div>
            <div className='label'>sur 2255</div>
          </div>
        </div>
      </div>

      <div className={'ta caption'}>{explanation}</div>
    </div>
  )
}

export type { Props as MunicipalityDetailProps }



// WEBPACK FOOTER //
// ./src/components/municipalityDetail/component.js